export interface OriginatorRulesState {
  originatorRules: any[],
  originatorRuleItem?: any
}

export interface OriginatorRuleFilter {
  originator?: string,
  partner?: string,
  service_provider?: string,
  page_number?: number
}

export class OriginatorRuleFilterImpl implements OriginatorRuleFilter{
  originator = undefined;
  partner = undefined;
  service_provider = undefined;
  page_number = 1;
}

export interface OriginatorRuleItem {
  id?: number
  originator?: string,
  originator_id?: number|null,
  partner?: string,
  partner_id?: number|null,
  service_provider?: string,
  service_provider_id?: number|null,
  new_originator?: string,
  pool?: string,
  pool_id?: number|null,
}

export class OriginatorRuleItemImpl implements OriginatorRuleItem{
  new_originator?: string
  pool_id?: number|null

  constructor() {
    this.pool_id = undefined
    this.new_originator = undefined
  }
}
